<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import ownersComposables from '@/composables/owners';
import { useContextRoot } from '@/utils/context-root';

import IdentityVerificationConsentModalV2 from '@/components/IdentityVerificationConsentModalV2.vue';
import DeployNotification from '@/components/DeployNotification.vue';
import ProgressGlobal from '@/components/progress/ProgressGlobal.vue';
import PopupApiError from '@/components/popups/PopupApiError.vue';
import Toast from 'primevue/toast';
import { RouteNames } from '@/data/routes';
import { flattenRouteNames } from '@/utils/router-helper';

const store = useStore();
const route = useRoute();
const userIsLoggedIn = computed(() => store.getters.userIsLoggedIn);
const { ownerVerificationStepComplete } = ownersComposables(useContextRoot());
const onboardingRouteNames = flattenRouteNames(RouteNames.ONBOARDING);
const emailVerificationRouteNames = flattenRouteNames(
  RouteNames.EMAIL_VERIFICATION,
);

const showConsentModal = computed(() => {
  return (
    userIsLoggedIn.value &&
    !ownerVerificationStepComplete.value &&
    !onboardingRouteNames.includes(route.name as string) &&
    !emailVerificationRouteNames.includes(route.name as string)
  );
});

const showProgressGlobal = computed(() => {
  return (
    route.name !== RouteNames.AUTH.LINK_ACCOUNTS &&
    route.name !== RouteNames.GCS_DOWNLOAD_PROXY.INDEX
  );
});
</script>

<template>
  <div data-cy="global-layout">
    <DeployNotification file-name="clearcom.js" />
    <ProgressGlobal v-if="showProgressGlobal" />
    <PopupApiError />
    <slot />
    <Toast :class="$style.toast" position="bottom-left" />

    <IdentityVerificationConsentModalV2
      v-if="showConsentModal"
      :dismissable="false"
    />
  </div>
</template>

<style module>
.toast {
  width: auto !important;
}

.toast [class^='p-toast-message-icon'] {
  align-self: center;
}
</style>
